import {
  ADD_MYSELF,
  ADD_MYSELF_FAILURE,
  ADD_MYSELF_SUCCESS,
  EDIT_MYSELF,
  EDIT_MYSELF_FAILURE,
  EDIT_MYSELF_SUCCESS,
} from '../Actiontype';

export const AddMySelf = data => ({
  payload: data,
  type: ADD_MYSELF,
});
export const AddMySelfSuccess = response => ({
  payload: response,
  type: ADD_MYSELF_SUCCESS,
});
export const AddMySelfFailure = response => ({
  payload: response,
  type: ADD_MYSELF_FAILURE,
});
export const EditMySelf = data => ({
  payload: data,
  type: EDIT_MYSELF,
});
export const EditMySelfSuccess = response => ({
  payload: response,
  type: EDIT_MYSELF_SUCCESS,
});
export const EditMySelfFailure = response => ({
  payload: response,
  type: EDIT_MYSELF_FAILURE,
});
